import { useQuery } from "react-query";
import { fetchAllOutstandingInvoices } from "../services/api/invoices";

export const useAccountInvoicesOutstanding = () => {
	return useQuery({
		queryKey: "Account.Invoices.Outstanding",
		queryFn: fetchAllOutstandingInvoices,
	});
};
